import { create as createFedopsLogger } from '@wix/fedops-logger'

export const fedopsLogger = createFedopsLogger('funnel-intro-viewer')
